import React, { useState, useEffect } from 'react';
import proptypes from 'prop-types';
const { string, number, bool, func } = proptypes;
import {
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Button } from '@one-thd/sui-atomic-components';
import { SubscribeDrawer } from './SubscribeDrawer';

const DisclaimerDrawer = ({
  discount = 0,
  openDrawer = false,
  onCloseClick = () => { },
  onIUnderstandClick = () => { }
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('disclaimer-drawer.ready'); }, []);

  return (
    <div data-component="DisclaimerDrawer">
      <SubscribeDrawer
        discount={discount}
        openDrawer={openDrawer}
        onCloseClick={onCloseClick}
        onIUnderstandClick={onIUnderstandClick}
      />
    </div>
  );
};

DisclaimerDrawer.propTypes = {
  discount: number.isRequired,
  openDrawer: bool.isRequired,
  onCloseClick: func.isRequired,
  onIUnderstandClick: func.isRequired
};

DisclaimerDrawer.displayName = 'DisclaimerDrawer';

DisclaimerDrawer.dataModel = {};

export { DisclaimerDrawer };
